<template>
  <InsightsTableContainer
    tooltip-key="hiring-table"
    download-id="hiring-report-table"
    :error="error"
    class="table"
    :empty-data="emptyData || noWidgetData"
    :loading="loading"
    label="Offer Data Table"
    :headers="tableHeaders"
    :rows="tableRows"
    :downloading="downloading"
    @download-csv="$emit('download-csv')"
  >
    <template #[`header:Resolved`]>
      <div class="w-full d-flex justify-space-between">
        <span>Resolved</span>
        <span>=</span>
        <span />
      </div>
    </template>
    <template #[`header:Accepted`]>
      <div class="w-full d-flex justify-space-between">
        <span>Accepted</span>
        <span>+</span>
        <span />
      </div>
    </template>
    <template #[`header:Declined`]>
      <div class="w-full d-flex justify-space-between">
        <span>Declined</span>
        <span>+</span>
        <span />
      </div>
    </template>
  </InsightsTableContainer>
</template>

<script setup>
import InsightsTableContainer from '@/components/insights/table/InsightsTableContainer.vue';
import { computed } from 'vue';

const props = defineProps({
  error: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  emptyData: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tableRows: {
    type: Array,
    default: () => [],
  },
  downloading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['download-csv']);

const noWidgetData = computed(() => !props.tableRows.length);

const tableHeaders = [
  'Resolved',
  'Accepted',
  'Declined',
  'Rescinded',
  'Current Open',
];
</script>

<style scoped lang="less">
:deep(.table-cell).value.new-body-text:not(:nth-child(2)):not(:nth-child(5)) {
  margin-right: 0px !important;
}
</style>
